webpackJsonp([7],{

/***/ "BGMK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var youtubeModalCtrl = (function () {
    youtubeModalCtrl.$inject = ["$transclude", "TutorialSvcFactory", "$location", "$timeout", "$stateParams", "$state"];
    function youtubeModalCtrl($transclude, TutorialSvcFactory, $location, $timeout, $stateParams, $state) {
        var _this = this;
        this.TutorialSvc = youtubeModalCtrl.TutorialSvcCache[$location.path()] ||
            (youtubeModalCtrl.TutorialSvcCache[$location.path()] = new TutorialSvcFactory());
        this.TutorialSvc.getVideo(this.videoId).then(function (video) {
            _this.videoDuration = _this.TutorialSvc.calcTime(video.duration);
            _this.videoName = video.title;
            _this.videoDesc = video.description;
            _this.thumbnail = video.thumbnails.default.url.replace('http:', 'https:');
            _this.slug = video.slug;
            $transclude(function (clone) { return $timeout(function () {
                var text = clone.text();
                if (text) {
                    _this.videoDesc = text;
                    _this.TutorialSvc.setVideoDescription(_this.videoId, text);
                }
            }); });
            if ($state.is('studio-tutorial') && $stateParams.video === video.slug) {
                _this.showVideo();
            }
        });
        this.TutorialSvc.addToQueue(this.videoId);
    }
    youtubeModalCtrl.prototype.showVideo = function () {
        this.TutorialSvc.openModal(this.videoId, parseInt(this.author, 10));
    };
    return youtubeModalCtrl;
}());
youtubeModalCtrl.TutorialSvcCache = {};
angular.module('animatronApp.tutorial')
    .component('youtubeModal', {
    controller: youtubeModalCtrl,
    controllerAs: 'youtubeModalCtrl',
    transclude: true,
    bindings: {
        videoId: '@',
        author: '@'
    },
    template: "<a ng-href=\"/studio/tutorial/{{::youtubeModalCtrl.slug}}\"\n                      ng-click=\"youtubeModalCtrl.showVideo()\" eat-click>\n                        <span class=\"yt-tutorail-preview-wrapper\">\n                            <img class=\"yt-tutorial-preview\" ng-src=\"{{::youtubeModalCtrl.thumbnail}}\" style=\"width:72px; height: 48px\" />\n                        </span>\n                        <span class=\"name\">{{::youtubeModalCtrl.videoName}}</span>\n                        <span class=\"duration\">{{::youtubeModalCtrl.videoDuration}} min</span>\n                   </a>\n                   <div class=\"description\">{{youtubeModalCtrl.videoDesc}}</div>"
});


/***/ }),

/***/ "BWKI":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/tutorials/tutorial-modal.html';
var html = "<div class=\"modal-container\"> <modal-dialog class=\"tutorialModal fullscreen\" close-button dont-auto-close show=\"$ctrl.TutorialSvcFactory.tutorialModalShown\" on-close=\"$ctrl.TutorialSvcFactory.onModalClose()\" additional-classes=\"wrapper-project-modal\"> <tutorial-video></tutorial-video> </modal-dialog> </div>";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "KtYt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

TutorialSvcFactory.$inject = ["$http", "$q", "$rootScope", "$state", "LocalStorageSvc"];
Object.defineProperty(exports, "__esModule", { value: true });
var SpinnerSvc_1 = __webpack_require__("pPBV");
var underscore_extensions_1 = __webpack_require__("R0iF");
var TutorialSvc = (function () {
    function TutorialSvc() {
        this.tutorialModalShown = false;
        this.videoList = [];
        this.videos = [];
        this.authors = [
            {
                id: 1,
                name: 'Bryce',
                avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
            },
            {
                id: 2,
                name: 'Alissa',
                avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
            },
            {
                id: 3,
                name: 'Priy',
                avatar: 'https://yt3.ggpht.com/-mpIivOOuI0A/AAAAAAAAAAI/AAAAAAAAAAA/lA445HV9NK4/s100-c-k-no-mo-rj-c0xffffff/photo.jpg'
            }
        ];
        this.isFirstFetch = true;
        TutorialSvc.$state = this.$state;
        TutorialSvc.$q = this.$q;
        this.defered = this.$q.defer();
        this.promise = this.defered.promise;
    }
    TutorialSvc.getProduct = function () {
        return underscore_extensions_1.Utils.getProduct().toLowerCase();
    };
    TutorialSvc.onModalClose = function () {
        this.changeUrl(TutorialSvc.getProduct() + "-tutorial", {}).then(function () {
            TutorialSvc.tutorialModalShown = false;
            SpinnerSvc_1.default.hide();
        });
    };
    TutorialSvc.prototype.addToQueue = function (videoId) {
        var _this = this;
        this.videos.push(videoId);
        setTimeout(function () {
            if (_this.videos.length === _this.countModalsOnPage()) {
                _this.fetchVideosData();
            }
        });
    };
    TutorialSvc.prototype.getVideo = function (id) {
        var _this = this;
        return this.promise.then(function () { return _this.findVideo(id); });
    };
    TutorialSvc.prototype.fetchVideosData = function () {
        var _this = this;
        if (this.isFirstFetch) {
            this.removeStorageData();
        }
        this.isFirstFetch = false;
        var cachedData = this.videos.map(function (id) { return _this.LocalStorageSvc.get(id); });
        var ids = this.videos.filter(function (id) { return !_.findWhere(cachedData, { id: id }); });
        if (ids.length > 0) {
            this.$q.all(this.chunkify(ids).map(function (chunk) {
                var idsStr = chunk.join(',');
                var params = "part=snippet,contentDetails&id=" + idsStr + "&key=" + TutorialSvc.youtubeApiKey;
                var youtubeApiUrl = "https://www.googleapis.com/youtube/v3/videos?" + params;
                return _this.$http.get(youtubeApiUrl);
            })).then(function (responses) {
                _this.videoList = _.flatten(responses.map(function (r) { return r.data.items; }))
                    .map(function (i) { return _this.processVideo(i); }).concat(cachedData);
                _this.defered.resolve();
            });
        }
        else {
            this.videoList = cachedData;
            this.defered.resolve();
        }
    };
    TutorialSvc.prototype.processVideo = function (videoItem) {
        var videoData = _.extend({ id: videoItem.id }, videoItem.snippet, videoItem.contentDetails);
        videoData.title = videoData.title.replace(TutorialSvc.videoTitleReg, '');
        videoData.description = videoData.description.replace(/Helpful Links[\s\S]*/, '').trim();
        videoData.description = videoData.description.replace(/Your Animatron Guru[\s\S]*/, '').trim();
        videoData.slug = this.slugify(videoData.title);
        this.LocalStorageSvc.set(videoData.id, videoData);
        return videoData;
    };
    TutorialSvc.prototype.calcTime = function (time) {
        var timeArr = _.last(time.match(/((\d+)M)?(\d+)S/), 2); // parse date format: 'PT1M10S'
        var minute = timeArr[0] || 0;
        var seconds = timeArr[1] || '0';
        var secondsStr = parseInt(seconds, 10) / 10 < 1 ? "0" + seconds : seconds.toString(); // if seconds = 3 then make 03
        return minute + ":" + secondsStr;
    };
    TutorialSvc.prototype.getCurrentVideo = function () {
        return TutorialSvc.currentVideo;
    };
    TutorialSvc.prototype.findVideo = function (id) {
        var video = _.findWhere(this.videoList, { id: id });
        if (video) {
            video.slug = video.slug || this.slugify(video.title);
        }
        return video;
    };
    TutorialSvc.prototype.setVideoDescription = function (id, text) {
        var video = this.findVideo(id);
        video.description = text;
    };
    TutorialSvc.prototype.countModalsOnPage = function () {
        var modalElName = TutorialSvc.getProduct() === 'wave' ? 'wave-tutorials-item' : 'youtube-modal';
        return this.modalsOnPage || (this.modalsOnPage = document.querySelectorAll(modalElName).length);
    };
    TutorialSvc.prototype.openModal = function (id, authorId) {
        var _this = this;
        this.getVideo(id).then(function (video) {
            TutorialSvc.currentVideo = video;
            TutorialSvc.tutorialModalShown = true;
            if (authorId) {
                TutorialSvc.currentVideo.author = _.findWhere(_this.authors, { id: authorId });
            }
            TutorialSvc.changeUrl(TutorialSvc.getProduct() + "-tutorial", { video: video.slug }).then(function () {
                _this.$rootScope.setTitle('project.title', video.title);
                _.each(document.head.querySelectorAll('[name$="description"], [property="og:description"]'), function (el) {
                    return el.content = video.description;
                });
            });
        });
    };
    TutorialSvc.prototype.removeStorageData = function () {
        var _this = this;
        this.videos.forEach(function (id) { return _this.LocalStorageSvc.remove(id); });
    };
    TutorialSvc.changeUrl = function (state, params, replace) {
        if (replace === void 0) { replace = false; }
        if (!this.$state.includes(state))
            return this.$q.resolve();
        var opts = {
            notify: false,
            location: (replace ? 'replace' : true)
        };
        return TutorialSvc.$state.transitionTo(state, params, opts);
    };
    TutorialSvc.prototype.slugify = function (text) {
        return text.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(/[^\w\-]+/g, '') // Remove all non-word chars
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, ''); // Trim - from end of text
    };
    TutorialSvc.prototype.chunkify = function (ids, limit) {
        if (limit === void 0) { limit = 50; }
        return ids.reduce(function (ar, it, i) {
            var ix = Math.floor(i / limit);
            if (!ar[ix])
                ar[ix] = [];
            ar[ix].push(it);
            return ar;
        }, []);
    };
    return TutorialSvc;
}());
TutorialSvc.videoTitleReg = /(\(Tutorial\))| (in Animatron)| (Using Animatron)/gi;
TutorialSvc.youtubeApiKey = 'AIzaSyDbtXVkjJEdvpaDGxWfFtSCNIAeHAqbcmQ';
TutorialSvc.tutorialModalShown = false;
exports.TutorialSvc = TutorialSvc;
function TutorialSvcFactory($http, $q, $rootScope, $state, LocalStorageSvc) {
    Object.assign(TutorialSvc.prototype, {
        $http: $http, $q: $q, $rootScope: $rootScope, $state: $state, LocalStorageSvc: LocalStorageSvc
    });
    return TutorialSvc;
}
angular.module('animatronApp.tutorial').factory('TutorialSvcFactory', TutorialSvcFactory);


/***/ }),

/***/ "Mc/u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var underscore_extensions_1 = __webpack_require__("R0iF");
var TutorialVideoCtrl = (function () {
    TutorialVideoCtrl.$inject = ["$sce", "TutorialSvcFactory", "TranslateSvc"];
    function TutorialVideoCtrl($sce, TutorialSvcFactory, TranslateSvc) {
        this.width = 720;
        this.height = 438;
        var tutorialSvc = new TutorialSvcFactory();
        var videoData = tutorialSvc.getCurrentVideo();
        var youtubeParams = underscore_extensions_1.Utils.toParams({
            autoplay: 1,
            hl: TranslateSvc.currentLang(),
            cc_load_policy: 1,
            fs: 1
        });
        if (videoData.author) {
            this.userName = videoData.author.name || videoData.channelTitle;
            this.userAvatar = videoData.author.avatar;
        }
        this.title = videoData.title;
        this.title = videoData.title.replace(/\|[\s\S]*/, '').trim();
        this.description = videoData.description.replace(/Discover our blog[\s\S]*|Read our blog[\s\S]*|Visit[\s\S]*|Not a member[\s\S]*/, '').trim();
        this.duration = tutorialSvc.calcTime(videoData.duration);
        this.videoId = videoData.id;
        var videoUrl = "https://www.youtube.com/embed/" + this.videoId + "?" + youtubeParams;
        this.videoUrl = $sce.trustAsResourceUrl(videoUrl);
    }
    return TutorialVideoCtrl;
}());
angular.module('animatronApp.tutorial')
    .component('tutorialVideo', {
    controller: TutorialVideoCtrl,
    controllerAs: 'TutorialVideoCtrl',
    templateUrl: __webpack_require__("zaE3")
});


/***/ }),

/***/ "QEkP":
/***/ (function(module, exports, __webpack_require__) {

var tutorials = [
    {
        title: 'tutorial.tools',
        videos: [
            {
                id: 'xDWloc9rsNY',
                author: 2,
                description: 'tutorial.tools.desc'
            }
        ]
    },
    {
        title: 'tutorial.shapes',
        videos: [
            {
                id: 'MTvJAbSTkBY',
                author: 2,
                description: 'tutorial.shapes.desc'
            },
            {
                id: 'cp5wTLvL9ak',
                author: 3,
                description: 'tutorial.shapes.desc2'
            }
        ]
    },
    {
        title: 'tutorial.color',
        videos: [
            {
                id: 'pTz8NYBtHlI',
                author: 3,
                description: 'tutorial.color.desc'
            },
            {
                id: 'OsXxDFuDR8Q',
                author: 3,
                description: 'tutorial.color.desc2'
            }
        ]
    },
    {
        title: 'tutorial.layers',
        videos: [
            {
                id: '7J_CtK0FCg8',
                author: 2,
                description: 'tutorial.layers.desc'
            },
            {
                id: 'kHK8MoOIlXg',
                author: 2,
                description: 'tutorial.layers.desc2'
            },
            {
                id: 'W2IGUdnacso',
                author: 3,
                description: 'tutorial.layers.desc3'
            }
        ]
    },
    {
        title: 'tutorial.timeline',
        videos: [
            {
                id: '9QMOI4OxNuI',
                author: 3,
                description: 'tutorial.timeline.desc'
            },
            {
                id: 'SY-B3WxxlJA',
                author: 3,
                description: 'tutorial.timeline.desc2'
            },
            {
                id: 'nhcrJHWaAZ0',
                author: 3,
                description: 'tutorial.timeline.desc3'
            }
        ]
    },
    {
        title: 'tutorial.audio',
        videos: [
            {
                id: '9r4T9OEebNs',
                author: 3,
                description: 'tutorial.audio.desc'
            },
            {
                id: 'lEs4zAZMwi0',
                author: 3,
                description: 'tutorial.audio.desc2'
            }
        ]
    },
    {
        title: 'tutorial.scenes',
        videos: [
            {
                id: 'p3VTKcds15g',
                author: 3,
                description: 'tutorial.scenes.desc'
            }
        ]
    },
    {
        title: 'tutorial.masks',
        videos: [
            {
                id: 'rE6FLLZcySk',
                author: 2,
                description: 'tutorial.masks.desc'
            },
            {
                id: 'EAWycSYrieU',
                author: 2,
                description: 'tutorial.masks.desc2'
            },
            {
                id: 'TGI-NRjarQ8',
                author: 2,
                description: 'tutorial.masks.desc3'
            },
            {
                id: '34vGqfE4o_I',
                author: 2,
                description: 'tutorial.masks.desc4'
            },
        ]
    },
    {
        title: 'tutorial.animation',
        videos: [
            {
                id: 'ytjUqhcOT0U',
                author: 1,
                description: 'tutorial.animation.desc3'
            },
            {
                id: 'YIZ2yWfbryU',
                author: 1,
                description: 'tutorial.animation.desc4'
            },
            {
                id: 'N7337YnRad0',
                author: 1,
                description: 'tutorial.animation.desc5'
            },
            {
                id: 'vcHJSINGLes',
                author: 1,
                description: 'tutorial.animation.desc6'
            },
            {
                id: 'vRvHKfiRNsY',
                author: 2,
                description: 'tutorial.animation.desc'
            },
            {
                id: 'bI3ojD2No54',
                author: 3,
                description: 'tutorial.animation.desc2'
            }
        ]
    },
];
var tips = [
    { id: 'DNk-oyyvGGk', author: 1 },
    { id: '4VJl-ibx9_w', author: 1 },
    { id: '7NFutKPFO0s', author: 1 },
    { id: 'YHWYN1FsTCQ', author: 1 },
    { id: '1wvNdSOubkQ', author: 1 },
    { id: 'f7AI_SqcmBE', author: 1 },
    { id: '2XHzxe3P61U', author: 1 },
    { id: '459VmqWO-lI', author: 1 },
    { id: 'pCrda1kArjc', author: 1 },
    { id: 'WRsrbQZPhw4', author: 1 },
    { id: 'SBifkl7XoKs', author: 1 },
    { id: 'pQ0E4Yuaogw', author: 1 },
    { id: '9ClIYY5CaH4', author: 1 },
    { id: 'iCggDw0PK0M', author: 1 },
    { id: 'ADFJloPaosA', author: 1 },
    { id: 'cq2CKiZZ3TY', author: 1 },
    { id: 'uh7cUGqi-D8', author: 1 },
    { id: 'XWsPbdJNJuY', author: 1 },
    { id: 'GV0iqA2JkyY', author: 1 },
    { id: 'ZDOVHJf7fw4', author: 1 },
    { id: 't8-to2eMLjI', author: 1 },
    { id: 'KdLwbLvqO84', author: 1 },
    { id: 'TlPrzpD_J6M', author: 1 },
    { id: 'oHGC_UMJj_w', author: 1 },
    { id: 'uRjbOcDLYzU', author: 1 },
    { id: 'hWwj9xIt01k', author: 1 },
    { id: 'kHL4HH78j3c', author: 1 },
    { id: 'E6URrqKbCjk', author: 1 },
    { id: 'i6E3wHaobh8', author: 1 },
    { id: 'pOMVMXSNypY', author: 1 },
    { id: 'ytjUqhcOT0U', author: 1 },
    { id: '2sKKDNSBG3Q', author: 1 },
    { id: 'qkGIFjwwkoM', author: 1 },
    { id: 'D3LG5sL9IZw', author: 1 },
    { id: 'QIFi5r8hSww', author: 1 },
    { id: 'QpBVQm9wzR8', author: 1 },
    { id: 'YMSZtPMTUD4', author: 1 },
    { id: 'BoZ3BYNeOpI', author: 1 },
    { id: 'e1N5F2VHhvs', author: 1 },
    { id: '_s8blVOWbNY', author: 1 },
    { id: 'u_R0iTTqqmg', author: 1 },
    { id: 'kV2g2vfLzqI', author: 1 },
    { id: '-lFarhidnWk', author: 1 },
    { id: 'CsL0UEh-1mA', author: 1 },
    { id: 'tTbyjARHR5M', author: 1 },
    { id: 'CmjFJ2XrpOk', author: 1 },
    { id: 'obkvNe8bVTU', author: 1 },
    { id: 'aubWACQnh0E', author: 1 },
    { id: 'b9ZWochAnog', author: 1 },
    { id: '13mGg5gmPL4', author: 1 }
];
var walkThus = [
    { id: 'kRhwrZWWaJI', author: 1 },
    { id: 'Q_8YTmE14qU', author: 1 },
    { id: 'CSc_tTRKp8s', author: 1 },
    { id: 'wmHQVbduoeE', author: 1 },
    { id: 'OXBHHXvStqo', author: 1 },
    { id: 'IF783XNBoQ0', author: 1 },
    { id: 'fTTu5C-79VE', author: 1 },
    { id: '_elQmdAy170', author: 1 },
    { id: 'uu7O0psuMa0', author: 1 }
];
var TutorialsPage = (function () {
    function TutorialsPage() {
        this.tutorialVideos = tutorials;
        this.tips = tips;
        this.walkThus = walkThus;
    }
    return TutorialsPage;
}());
angular.module('animatronApp.tutorial').component('tutorialsPage', {
    controller: TutorialsPage,
    templateUrl: __webpack_require__("plSH")
});


/***/ }),

/***/ "f/MV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TutorialModal = (function () {
    TutorialModal.$inject = ["TutorialSvcFactory"];
    function TutorialModal(TutorialSvcFactory) {
        this.TutorialSvcFactory = TutorialSvcFactory;
    }
    return TutorialModal;
}());
angular.module('animatronApp.tutorial').component('tutorialModal', {
    controller: TutorialModal,
    templateUrl: __webpack_require__("BWKI")
});


/***/ }),

/***/ "plSH":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/tutorial.html';
var html = "<tutorial-modal></tutorial-modal> <modal-dialog show=\"expertTutorialModalShown\" class=\"fullscreen\" additional-classes=\"landing-modal\"> <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/8SoKASkCuuw?autoplay=1;rel=0\" frameborder=\"0\" allowfullscreen></iframe> </modal-dialog> <modal-dialog show=\"liteModeTutorialModalShown\" class=\"fullscreen\" additional-classes=\"landing-modal\"> <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/Hl6tghsSKmA?autoplay=1;rel=0\" frameborder=\"0\" allowfullscreen></iframe> </modal-dialog> <div class=\"long-head-top\"> <h1>{{::$root.t('tutorial.h1')}}</h1> <h2>{{::$root.t('tutorial.h2')}}</h2> <div class=\"top-videos\"> <div class=\"video-content\"> <h4 class=\"top-video-title\">{{::$root.t('tutorial.lite_mode.video.title')}}</h4> <div ng-click=\"liteModeTutorialModalShown=true\" class=\"landing-video-preview\"> <img style=\"height:268px;width:428px\" ng-src=\"https://img.youtube.com/vi/Hl6tghsSKmA/maxresdefault.jpg\"> </div> </div> <div class=\"video-content\"> <h4 class=\"top-video-title\">{{::$root.t('tutorial.expert_mode.video.title')}}</h4> <div ng-click=\"expertTutorialModalShown=true\" class=\"landing-video-preview\"> <img style=\"height:268px;width:428px\" ng-src=\"https://img.youtube.com/vi/8SoKASkCuuw/maxresdefault.jpg\"> </div> </div> </div> </div> <div class=\"tutorials-content-wrapper\"> <div class=\"tabs-container\"> <tabs default-tab=\"tips\" tabs=\"['tips', 'tutorials', 'walk-thrus']\" current-tab=\"currentTab\" class=\"tutorial-tabs\"></tabs> <div class=\"search-block projects-header\"> <input class=\"project-search\" ng-class=\"{active: searchText}\" placeholder=\"{{::$root.t('search')}}\" type=\"text\" ng-model=\"searchText\"/> </div> </div> <div class=\"tutorials category-list\" ng-show=\"currentTab === 'tutorials'\"> <section search-text=\"searchText\" search-element=\"youtube-modal\" ng-repeat=\"tutorial in $ctrl.tutorialVideos\"> <h3 class=\"tutorials-category-title\">{{::$root.t(tutorial.title)}}</h3> <div class=\"tutorials-category-wrapper\"> <youtube-modal ng-repeat=\"video in tutorial.videos\" video-id=\"{{::video.id}}\" author=\"{{::video.author}}\">{{::$root.t(video.description)}} </youtube-modal> </div> </section> <div class=\"tutorial-search-result not-found-msg icon-status-msg icon-search-no-result\"> <span>{{searchText}} - {{::$root.t('tutorial.tutorials.not-found')}}</span> </div> </div> <div class=\"quick-tips category-list\" ng-show=\"currentTab === 'tips'\"> <youtube-modal search-text=\"searchText\" ng-repeat=\"tip in $ctrl.tips\" video-id=\"{{::tip.id}}\" author=\"{{::tip.author}}\"></youtube-modal> <div class=\"tutorial-search-result not-found-msg icon-status-msg icon-search-no-result\"> <span>{{searchText}} - {{::$root.t('tutorial.tips.not-found')}}</span> </div> </div> <div class=\"tutorials category-list\" ng-show=\"currentTab === 'walk-thrus'\"> <youtube-modal search-text=\"searchText\" ng-repeat=\"wt in $ctrl.walkThus\" video-id=\"{{::wt.id}}\" author=\"{{::wt.author}}\"></youtube-modal> <div class=\"tutorial-search-result not-found-msg icon-status-msg icon-search-no-result\"> <span>{{searchText}} - {{::$root.t('tutorial.walk-thrus.not-found')}}</span> </div> </div> </div>";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ }),

/***/ "zaE3":
/***/ (function(module, exports) {

var path = 'https://assets.animatron.com/html/tutorials/tutorial-video.html';
var html = "<div class=\"wrapper-proj\" ng-style=\"{width:TutorialVideoCtrl.width+20+'px'}\"> <div class=\"project-wrapper tutorial-video\"> <div id=\"project-player\" class=\"project-border\"> <div class=\"movie-body\"> <iframe ng-src=\"{{TutorialVideoCtrl.videoUrl}}\" width=\"{{TutorialVideoCtrl.width}}\" height=\"{{TutorialVideoCtrl.height}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> </div> </div> <div class=\"project-summary\"> <div class=\"project-info\"> <div class=\"project-main-info\"> <h4 class=\"project-title-wrapper\"> <span class=\"project-title\">{{TutorialVideoCtrl.title}}</span> <span class=\"duration\">{{TutorialVideoCtrl.duration}} min</span> </h4> <div class=\"pull-left avatar\" ng-if=\"TutorialVideoCtrl.userAvatar\"> <img width=\"30\" height=\"30\" ng-src=\"{{TutorialVideoCtrl.userAvatar}}\"> </div> <p class=\"author-name\" ng-if=\"TutorialVideoCtrl.userName\"> {{TutorialVideoCtrl.userName}} </p> </div> </div> <div class=\"project-info\" ng-if=\"$root.isStudio\"> <p class=\"project-description\">{{TutorialVideoCtrl.description}}</p> </div> </div> </div> </div> ";
var angular = window.angular;
var injector = angular.element(document).injector();
if (injector) {
injector.get('$templateCache').put(path, html);
} else {
angular.module('templates').run(['$templateCache', function(c) { c.put(path, html) }]);
}
module.exports = path;

/***/ })

});


// WEBPACK FOOTER //
// javascripts/7-0e7693f8a3788edda5d0.min.js